/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorFormulaElementType'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorFormulaElementType'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorFormulaElementTypeApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorFormulaElementType);
  }
}(this, function(ApiClient, PerformanceIndicatorFormulaElementType) {
  'use strict';

  /**
   * PerformanceIndicatorFormulaElementType service.
   * @module api/PerformanceIndicatorFormulaElementTypeApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorFormulaElementTypeApi. 
   * @alias module:api/PerformanceIndicatorFormulaElementTypeApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorFormulaElementTypeLoadAllGet operation.
     * @callback module:api/PerformanceIndicatorFormulaElementTypeApi~performanceIndicatorFormulaElementTypeLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorFormulaElementType>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/PerformanceIndicatorFormulaElementTypeApi~performanceIndicatorFormulaElementTypeLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorFormulaElementType>}
     */
    this.performanceIndicatorFormulaElementTypeLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorFormulaElementTypeLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorFormulaElementType];

      return this.apiClient.callApi(
        '/PerformanceIndicatorFormulaElementType/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
